__webpack_require__.p = "https://nt-com-chatnt.pages.dev/";